import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { Timer } from 'src/components/ui'
import { BottleType } from 'src/pages/Bottle/Bottles.types'

import { calculateCountdown } from '../../../../utils/calculateCountdown'
import IconBottleCharacteristics from '../IconBottleCharacteristics/IconBottleCharacteristics'
import styles from './Bottle.module.scss'

const Bottle = (bottle: BottleType) => {
  const { name, type, total_stars, participants_count, start_date, available_until, id } = bottle
  const { t } = useTranslation()

  const { time, message } = calculateCountdown(available_until, start_date)
  const planned = message === 'Start is expected'

  const { pathname } = useLocation()

  return (
    <Link
      to={String(id)}
      state={{ from: pathname }}
      className={`${styles.bottle} ${type === 'FIXED' ? styles.fixed : styles.default}`}
    >
      <div className={styles.bottle_header}>
        <p>{name}</p>
      </div>

      <div className={styles.bottle_characteristics}>
        <IconBottleCharacteristics
          name='type_of_bottle'
          text={type === 'FIXED' ? t('bottle_item.fixed') : t('bottle_item.any')}
        />
        <IconBottleCharacteristics name='amountOfBottle' text={!planned ? Math.abs(total_stars || 0) : '?'} />
        <IconBottleCharacteristics name='peopleOfBottle' text={!planned ? participants_count || 0 : '?'} />
      </div>

      <div className={styles.bottle_footer}>
        <Timer
          time={planned ? t('bottle_item.start_is_expected') : time}
          className={styles['bottle_footer-timer']}
          variant='text'
        />
      </div>
    </Link>
  )
}

export default Bottle
